export const moduleSlug = "wallet";
export const moduleAuth = "Wallet";

export const children = [
  {
    path: "",
    component: () => import("./pages/Customers.vue"),
    meta: {
      title: "Customers",
      linkTitle: "Customers",
      linkIcon: "list",
      showInNav: true,
      permission: "Wallet.Customers",
    },
  },
  {
    path: "transactions",
    component: () => import("./pages/Transactions.vue"),
    meta: {
      title: "Transactions",
      linkTitle: "Transactions",
      linkIcon: "list",
      showInNav: true,
      permission: "Wallet.Transactions",
    },
  },
  {
    path: 'config/settings',
    component: () => import('@/components/Configuration/Configurations.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Configurations',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: "Wallet.Config.Settings",
    }
  }
];

export const quickLinks = [
  {
    name: 'Settings',
    link: `/${moduleSlug}/config/settings`,
    new: true,
    brandFlag: 'enableConfigurations',
    permission: 'Wallet.Config.Settings',
  }
];
